import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { StorageKeys } from '@core/enums';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  readonly #jwtHelper = new JwtHelperService();

  // Salvar token no armazenamento
  saveToken(token: string): void {
    if (token) {
      sessionStorage.setItem(StorageKeys.CAT, token);
    }
  }

  // Recuperar token do armazenamento
  getToken(): string | null {
    return sessionStorage.getItem(StorageKeys.CAT);
  }

  // Remover token do armazenamento
  clearToken(): void {
    sessionStorage.removeItem(StorageKeys.CAT);
  }

  // Verificar se existe um token válido
  hasToken(): boolean {
    const token = this.getToken();
    return !!token && !this.isTokenExpired();
  }

  // Verificar se o token está expirado
  isTokenExpired(): boolean {
    const token = this.getToken();
    if (!token || token.split('.').length !== 3) {
      console.warn('Token inválido ou ausente.');
      return true;
    }
    try {
      return this.#jwtHelper.isTokenExpired(token);
    } catch (error) {
      console.error('Erro ao validar o token:', error);
      return true;
    }
  }
}
